/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createEffectiveLaborCost } from '../fn/effective-labor-cost/create-effective-labor-cost';
import { CreateEffectiveLaborCost$Params } from '../fn/effective-labor-cost/create-effective-labor-cost';
import { deleteEffectiveLaborCost } from '../fn/effective-labor-cost/delete-effective-labor-cost';
import { DeleteEffectiveLaborCost$Params } from '../fn/effective-labor-cost/delete-effective-labor-cost';
import { EffectiveLaborCostDto } from '../models/effective-labor-cost-dto';
import { EffectiveLaborCostDtoPage } from '../models/effective-labor-cost-dto-page';
import { exportEffectiveLaborCosts } from '../fn/effective-labor-cost/export-effective-labor-costs';
import { ExportEffectiveLaborCosts$Params } from '../fn/effective-labor-cost/export-effective-labor-costs';
import { getEffectiveLaborCost } from '../fn/effective-labor-cost/get-effective-labor-cost';
import { GetEffectiveLaborCost$Params } from '../fn/effective-labor-cost/get-effective-labor-cost';
import { listEffectiveLaborCosts } from '../fn/effective-labor-cost/list-effective-labor-costs';
import { ListEffectiveLaborCosts$Params } from '../fn/effective-labor-cost/list-effective-labor-costs';
import { updateEffectiveLaborCost } from '../fn/effective-labor-cost/update-effective-labor-cost';
import { UpdateEffectiveLaborCost$Params } from '../fn/effective-labor-cost/update-effective-labor-cost';

@Injectable({ providedIn: 'root' })
export class EffectiveLaborCostApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEffectiveLaborCosts()` */
  static readonly ListEffectiveLaborCostsPath = '/v0/effectiveLaborCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEffectiveLaborCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEffectiveLaborCosts$Response(params?: ListEffectiveLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveLaborCostDtoPage>> {
    return listEffectiveLaborCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEffectiveLaborCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEffectiveLaborCosts(params?: ListEffectiveLaborCosts$Params, context?: HttpContext): Observable<EffectiveLaborCostDtoPage> {
    return this.listEffectiveLaborCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveLaborCostDtoPage>): EffectiveLaborCostDtoPage => r.body)
    );
  }

  /** Path part for operation `createEffectiveLaborCost()` */
  static readonly CreateEffectiveLaborCostPath = '/v0/effectiveLaborCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEffectiveLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEffectiveLaborCost$Response(params: CreateEffectiveLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return createEffectiveLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEffectiveLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEffectiveLaborCost(params: CreateEffectiveLaborCost$Params, context?: HttpContext): Observable<string> {
    return this.createEffectiveLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getEffectiveLaborCost()` */
  static readonly GetEffectiveLaborCostPath = '/v0/effectiveLaborCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEffectiveLaborCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveLaborCost$Response(params: GetEffectiveLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveLaborCostDto>> {
    return getEffectiveLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEffectiveLaborCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveLaborCost(params: GetEffectiveLaborCost$Params, context?: HttpContext): Observable<EffectiveLaborCostDto> {
    return this.getEffectiveLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveLaborCostDto>): EffectiveLaborCostDto => r.body)
    );
  }

  /** Path part for operation `updateEffectiveLaborCost()` */
  static readonly UpdateEffectiveLaborCostPath = '/v0/effectiveLaborCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEffectiveLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEffectiveLaborCost$Response(params: UpdateEffectiveLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveLaborCostDto>> {
    return updateEffectiveLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEffectiveLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEffectiveLaborCost(params: UpdateEffectiveLaborCost$Params, context?: HttpContext): Observable<EffectiveLaborCostDto> {
    return this.updateEffectiveLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveLaborCostDto>): EffectiveLaborCostDto => r.body)
    );
  }

  /** Path part for operation `deleteEffectiveLaborCost()` */
  static readonly DeleteEffectiveLaborCostPath = '/v0/effectiveLaborCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEffectiveLaborCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEffectiveLaborCost$Response(params: DeleteEffectiveLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEffectiveLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEffectiveLaborCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEffectiveLaborCost(params: DeleteEffectiveLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.deleteEffectiveLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportEffectiveLaborCosts()` */
  static readonly ExportEffectiveLaborCostsPath = '/v0/effectiveLaborCost/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportEffectiveLaborCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEffectiveLaborCosts$Response(params?: ExportEffectiveLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return exportEffectiveLaborCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportEffectiveLaborCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEffectiveLaborCosts(params?: ExportEffectiveLaborCosts$Params, context?: HttpContext): Observable<string> {
    return this.exportEffectiveLaborCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
